/**
 * Breadcrumb's class properties inherits from properties in Vuetify's v-breadcrumbs items
 */
export default class Breadcrumb {
	constructor(args) {
		this.activeClass = args.activeClass;
		this.append = args.append;
		this.disabled = args.disabled;
		this.exact = args.exact;
		this.exactActiveClass = args.exactActiveClass;
		this.href = args.href;
		this.link = args.link;
		this.replace = args.replace;
		this.ripple = args.ripple;
		this.tag = args.tag;
		this.target = args.target;
		this.text = args.text;
		this.to = args.to;
	}
}
